import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Structured error reporting — no console.log
    if (typeof window !== 'undefined' && window.__ERROR_HANDLER__) {
      window.__ERROR_HANDLER__(error, errorInfo);
    }
  }

  render() {
    const { hasError } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      if (fallback) {
        return fallback;
      }

      return (
        <div className="d-flex flex-column align-items-center justify-content-center p-4">
          <div
            className="card shadow-sm"
            style={{ maxWidth: '500px', width: '100%' }}
          >
            <div className="card-body text-center">
              <h5 className="card-title text-danger mb-3">
                Something went wrong
              </h5>
              <p className="card-text text-muted mb-3">
                An unexpected error occurred. Please try refreshing the page.
              </p>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  this.setState({ hasError: false });
                  window.location.reload();
                }}
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

export default ErrorBoundary;
